import React, { useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { map, slice } from "ramda";

import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";

import { notBlank } from "../../util/ext";
import { TableFooter } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import { Link, useRouteMatch } from "react-router-dom";

const ROWS_PER_PAGE = 15;

const useStyles = makeStyles(theme => ({
  root: {
    width: "calc(100% + 12px)",
    marginLeft: "-6px",
    borderRadius: "20px",
  },

  link: {
    color: theme.palette.primary.brandPrimary,
  },

  tableContainer: {
    height: "calc(100vh - 350px)",
    overflow: "auto",
  },

  pagination: {
    color: theme.palette.primary.darker,
    backgroundColor: "white",
    borderRadius: "20px",
  },
}));

const JobChunksTable = props => {
  const { chunks, page, onPageChange, onScrollVisible } = props;

  const classes = useStyles();
  const { url } = useRouteMatch();

  //-- Track if the scroll bar is visible
  const tableContainerEl = useRef(null);
  useEffect(() => {
    if (notBlank(tableContainerEl)) {
      const element = tableContainerEl.current;
      const scrollVisible = element.scrollHeight > element.clientHeight;
      onScrollVisible(scrollVisible);
    }
  }, [onScrollVisible]);

  return (
    <Paper elevation={0} className={classes.root}>
      <TableContainer className={classes.tableContainer} ref={tableContainerEl}>
        <Table stickyHeader aria-label="Item">
          <TableHead>
            <TableRow>
              <TableCell
                key="chunkId"
                align="left"
                style={{ minWidth: 75, maxWidth: 600 }}
              >
                Chunk Id
              </TableCell>

              <TableCell
                key="mediaId"
                align="left"
                style={{ minWidth: 75, maxWidth: 600 }}
              >
                Media id
              </TableCell>

              <TableCell
                key="title"
                align="left"
                style={{ minWidth: 75, maxWidth: 600 }}
              >
                Title
              </TableCell>

              <TableCell
                key="isbn"
                align="left"
                style={{ minWidth: 75, maxWidth: 600 }}
              >
                ISBN
              </TableCell>

              <TableCell
                key="type"
                align="left"
                style={{ minWidth: 75, maxWidth: 600 }}
              >
                Type
              </TableCell>

              <TableCell
                key="status"
                align="left"
                style={{ minWidth: 75, maxWidth: 600 }}
              >
                Status
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {map(
              chunk => (
                <TableRow hover tabIndex={-1} key={chunk.chunkId}>
                  <TableCell
                    key={"chunkId:" + chunk.chunkId}
                    align="left"
                    style={{ minWidth: 75, maxWidth: 600 }}
                  >
                    <Tooltip title="View Chunk Details">
                      <Link
                        className={classes.link}
                        to={`${url}/${chunk.chunkId}`}
                      >
                        {chunk.chunkId}
                      </Link>
                    </Tooltip>
                  </TableCell>

                  <TableCell
                    key={"media-id:" + chunk.chunkId}
                    align="left"
                    style={{ minWidth: 75, maxWidth: 600 }}
                  >
                    {chunk.mediaId}
                  </TableCell>

                  <TableCell
                    key={"title:" + chunk.chunkId}
                    align="left"
                    style={{ minWidth: 75, maxWidth: 600 }}
                  >
                    {chunk.title}
                  </TableCell>

                  <TableCell
                    key={"isbn:" + chunk.chunkId}
                    align="left"
                    style={{ minWidth: 75, maxWidth: 600 }}
                  >
                    {chunk.isbn}
                  </TableCell>

                  <TableCell
                    key={"type:" + chunk.chunkId}
                    align="left"
                    style={{ minWidth: 75, maxWidth: 600 }}
                  >
                    {chunk.mediaType}
                  </TableCell>

                  <TableCell
                    key={"status:" + chunk.chunkId}
                    align="left"
                    style={{ minWidth: 75, textTransform: "capitalize" }}
                  >
                    {chunk.status}
                  </TableCell>
                </TableRow>
              ),
              slice(
                page * ROWS_PER_PAGE,
                page * ROWS_PER_PAGE + ROWS_PER_PAGE,
                chunks,
              ),
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                classes={{
                  root: classes.pagination,
                }}
                colSpan={6}
                count={chunks.length}
                rowsPerPageOptions={[ROWS_PER_PAGE]}
                rowsPerPage={ROWS_PER_PAGE}
                page={page}
                onChangePage={onPageChange}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default JobChunksTable;
